import { Component, ElementRef } from "@angular/core";

@Component({
    selector: "ng-scripts-google",
    template: `<noscript><iframe src="//www.googletagmanager.com/ns.html?id=GTM-NL7C6V" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`
})
export class NgScriptsGoogleComponent {
    constructor() {
        if (self === top) {
            const theBody = document.getElementsByTagName("body")[0];
            theBody.style.display = "block";
        } else {
            top.location = self.location;
        }
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                "gtm.start": new Date().getTime(),
                event: "gtm.js"
            });
            const f = d.getElementsByTagName(s)[0],
                j: any = d.createElement(s),
                dl = l !== "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "//www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", "GTM-NL7C6V");
    }
}
